import theme from "../styles/theme";

// Liste des clés disponibles dans ta palette
const COLOR_KEYS = Object.keys(theme.Avatar.colors);

// Hash simple et robuste
function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

// Retourne une clé couleur cohérente ("blue", "green", etc.)
export function getUserColor(label) {
  if (!label || typeof label !== "string") {
    return "grey"; // fallback
  }

  const index = hash(label) % COLOR_KEYS.length;
  return COLOR_KEYS[index];
}
